export default {
	save: 'Save bookmark',
	load: 'Load bookmark',
	saved: 'Bookmark saved!',
	loaded: 'Bookmark loaded!',
	deleted: 'Bookmark deleted!',
	notFound: 'Bookmark could not be found!',
	empty: 'No bookmarks saved.',
}
